"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionsDashboardWidget = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("@veeam/core");
const components_1 = require("@veeam/components");
const external_svg_1 = __importDefault(require("../../../../assets/icons/external.svg"));
const Error_svg_1 = __importDefault(require("../../../../assets/icons/dashboard/Error.svg"));
const Warning_svg_1 = __importDefault(require("../../../../assets/icons/dashboard/Warning.svg"));
const Success_svg_1 = __importDefault(require("../../../../assets/icons/dashboard/Success.svg"));
const Running_svg_1 = __importDefault(require("../../../../assets/icons/dashboard/Running.svg"));
const components_2 = require("../../../../components");
const core_2 = require("../../../../core");
const SessionsInteractor_1 = require("./SessionsInteractor");
const types_1 = require("./types");
const components_3 = require("./components");
const SessionsDashboardWidget = ({ loadableModel, onShowMoreClick, onRowClick, }) => {
    const { t } = core_2.useFeatureContext();
    core_1.useInteractor(() => {
        return new SessionsInteractor_1.SessionsInteractor(loadableModel);
    });
    const { value, meta: { loading: isLoading }, } = core_1.useModel(loadableModel);
    const handleRowClick = (type) => {
        return onRowClick ? () => onRowClick(type) : undefined;
    };
    const HeaderAddon = () => (react_1.default.createElement("div", { style: {
            flex: 1,
            justifyContent: 'flex-end',
        } },
        react_1.default.createElement(components_1.LinkButton, { iconBefore: external_svg_1.default, onClick: onShowMoreClick, style: { display: 'flex' } }, t('dashboard|sessions|action|viewMore'))));
    return (react_1.default.createElement(components_2.DashboardPlate, { title: t('dashboard|sessions|header'), headerAddon: !isLoading ? react_1.default.createElement(HeaderAddon, null) : undefined, viewMoreIcon: external_svg_1.default, content: react_1.default.createElement(components_2.TableWidget, { isLoading: isLoading, rows: [
                {
                    id: 'errorRow',
                    onClick: handleRowClick(types_1.SESSIONS_WIDGET_ROW_TYPES.error),
                    content: (react_1.default.createElement(components_3.SessionRow, { icon: Error_svg_1.default, text: t('dashboard|sessions|error'), value: value.errorCount, countDifference: value.errorCountDifference })),
                },
                {
                    id: 'warningRow',
                    onClick: handleRowClick(types_1.SESSIONS_WIDGET_ROW_TYPES.warning),
                    content: (react_1.default.createElement(components_3.SessionRow, { icon: Warning_svg_1.default, text: t('dashboard|sessions|warning'), value: value.warningCount, countDifference: value.warningCountDifference })),
                },
                {
                    id: 'successRow',
                    onClick: handleRowClick(types_1.SESSIONS_WIDGET_ROW_TYPES.success),
                    content: (react_1.default.createElement(components_3.SessionRow, { icon: Success_svg_1.default, text: t('dashboard|sessions|success'), value: value.successCount, countDifference: value.successCountDifference })),
                },
                {
                    id: 'runningRow',
                    onClick: handleRowClick(types_1.SESSIONS_WIDGET_ROW_TYPES.running),
                    content: (react_1.default.createElement(components_3.SessionRow, { icon: Running_svg_1.default, text: t('dashboard|sessions|running'), value: value.runningCount })),
                },
            ] }) }));
};
exports.SessionsDashboardWidget = SessionsDashboardWidget;
//# sourceMappingURL=SessionsDashboardWidget.js.map